import { Component, OnInit } from '@angular/core';
import { AssemblyService } from '../../_services/assembly/assembly.service';

@Component({
  moduleId: module.id,
  selector: 'footer-cmp',
  templateUrl: 'footer.component.html'
})

export class FooterComponent {

  public assemblyVersion: string;

  constructor(private pAssemblyService: AssemblyService) {

  }

  test: Date = new Date();

  async getAssemblyVersion() {
    //await this.pAssemblyService.getAssemblyVersion().then(x => {
    //  this.assemblyVersion = x.text.toString();
    //}, err => console.error(err));
  }
}
